export enum MedicalAreaTabs {
    CONSULTATION_TYPE = "CONSULTATION_TYPE",
}